/**
 * Shared empty-state shown when a game has no winnable prizes (every stock is
 * out of stock / `available <= 0`). Reuses the existing wheel empty strings so
 * no new i18n keys are needed.
 */
import { useT } from '@/lib/i18n/useT';

export function GameEmpty() {
  const t = useT();
  return (
    <div className="rounded-2xl bg-black/40 p-8 text-center text-white">
      <p className="font-bold">{t('publicSurvey.wheel.emptyTitle')}</p>
      <p className="mt-1 text-sm opacity-70">{t('publicSurvey.wheel.emptyBody')}</p>
    </div>
  );
}
